import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();
  if (!value) {
    return '';
  }

  const { count, status } = value;
  let icon = '';

  switch (status.toUpperCase()) {
    case 'PAID':
      icon = cygnusSpriteHtml('check-circle', { variant: 'solid', className: 'text-success', title: 'Paid' })
      break;
    case 'INVOICED':
      icon = cygnusSpriteHtml('check-circle', { variant: 'solid', className: 'text-warning', title: 'Invoiced' })
      break;
    case 'AWAITING_INVOICE':
      icon = cygnusSpriteHtml('warning', { variant: 'solid', className: 'text-warning', title: 'Awaiting Invoice' })
      break;
    case 'NONE':
      icon = cygnusSpriteHtml('x-circle', { variant: 'solid', className: 'text-danger', title: 'No PO' });
      break;
    default:
      icon = cygnusSpriteHtml('x-circle', { variant: 'solid', className: 'text-danger' })
      break;
  }

  const el = document.createElement('div');
  el.classList.add('d-flex', 'flex-column', 'align-items-center');


  el.innerHTML = `<div>${icon}</div><div>${count}</div>`;
  return el;
}
